<ng-container>
  <ngx-dropzone
    [ngStyle]="{
      background: 'url(assets/images/newsletter-bg.jpg)',
      'background-size': 'cover',
      'background-position': 'center',
      'aspect-ratio': size.aspectRatio
    }"
    [accept]="accept"
    [multiple]="multiple"
    [expandable]="false"
    (change)="prepare($event)">
    <ngx-dropzone-label *ngIf="!media || !media.url">
      <i class="bx bxs-download"></i><br />
      {{ label }}
    </ngx-dropzone-label>
    <ngx-dropzone-image-preview
      *ngIf="media && media.file"
      (removed)="onRemove(media)"
      [file]="media.file"
      [removable]="true">
    </ngx-dropzone-image-preview>
    <div
      class="ngx-dropzone-image-preview"
      *ngIf="media && !media.file && media.url">
      <img [src]="media.url" [alt]="media.name" />
    </div>
  </ngx-dropzone>
  <a (click)="openModal()" class="btn btn-primary mx-2 mx-sm-0">
    Stock <i class="bx bx-collection"></i>
  </a>
</ng-container>
